<!-- <router-outlet></router-outlet> -->

<cj-layout>
  <cj-layout-column>
    <router-outlet></router-outlet>
  </cj-layout-column>
</cj-layout>